import { getItemByField } from "../../../../web-graphics";

function createPanelUserSettings(viewObjectSettings) {
  let userViewObjectSettings = {
    type: "panel"
  };
  if (viewObjectSettings.items === undefined) {
    return userViewObjectSettings;
  }
  userViewObjectSettings.items = [];
  for (let i = 0; i < viewObjectSettings.items.length; i++) {
    userViewObjectSettings.items.push(createViewObjectUserSettings(viewObjectSettings.items[i]));
  }
  return userViewObjectSettings;
}

function createGridUserSettings(viewObjectSettings) {
  let userViewObjectSettings = {
    type: "grid",
    rows: []
  };
  if (viewObjectSettings.rows === undefined) {
    return userViewObjectSettings;
  }
  for (let rowIndex = 0; rowIndex < viewObjectSettings.rows.length; rowIndex++) {
    let rowSettings = viewObjectSettings.rows[rowIndex];
    let userRowSettings = {
      columns: []
    };
    if (rowSettings.columns === undefined) {
      userViewObjectSettings.rows.push(userRowSettings);
      break;
    }
    for (let columnIndex = 0; columnIndex < rowSettings.columns.length; columnIndex++) {
      let cellSettings = rowSettings.columns[columnIndex];
      let userCellSettings = {
        item: createViewObjectUserSettings(cellSettings.item)
      };
      userRowSettings.columns.push(userCellSettings);
    }
    userViewObjectSettings.rows.push(userRowSettings);
  }
  return userViewObjectSettings;
}

function createColumnGridUserSettings(viewObjectSettings) {
  let userViewObjectSettings = {
    type: "column-grid",
    columns: []
  };
  if (viewObjectSettings.columns === undefined) {
    return userViewObjectSettings;
  }
  for (let columnIndex = 0; columnIndex < viewObjectSettings.columns.length; columnIndex++) {
    let columnSettings = viewObjectSettings.columns[columnIndex];
    let userColumnSettings = {
      rows: []
    };
    if (columnSettings.rows === undefined) {
      userViewObjectSettings.columns.push(userColumnSettings);
      break;
    }
    for (let rowIndex = 0; rowIndex < columnSettings.rows.length; rowIndex++) {
      let cellSettings = columnSettings.rows[rowIndex];
      let userCellSettings = {
        item: createViewObjectUserSettings(cellSettings.item)
      };
      userColumnSettings.rows.push(userCellSettings);
    }
    userViewObjectSettings.columns.push(userColumnSettings);
  }
  return userViewObjectSettings;
}

function createTableUserSettings(viewObjectSettings) {
  let userViewObjectSettings = {
    type: "table",
    items: []
  };
  if (viewObjectSettings.items === undefined) {
    return userViewObjectSettings;
  }
  for (let rowIndex = 0; rowIndex < viewObjectSettings.items.length; rowIndex++) {
    let rowItems = viewObjectSettings.items[rowIndex];
    let userRowItems = [];
    for (let columnIndex = 0; columnIndex < rowItems.length; columnIndex++) {
      userRowItems.push(createViewObjectUserSettings(rowItems[columnIndex]));
    }
    userViewObjectSettings.items.push(userRowItems);
  }
  return userViewObjectSettings;
}

function createPlotUserSettings(viewObjectSettings) {
  let signalsSettings = getItemByField("name", "signals", viewObjectSettings.plotContent)?.settings;
  return {
    type: "plot",
    defaultFilters: signalsSettings.defaultFilters,
    defaultScaleYIndex: signalsSettings.defaultScaleYIndex,
    defaultScaleXIndex: signalsSettings.defaultScaleXIndex
  };
}

function createRhythmPlotUserSettings(viewObjectSettings) {
  let signalsSettings = getItemByField("name", "signals", viewObjectSettings.plotContent)?.settings;
  return {
    type: "rhythm-plot",
    defaultFilters: signalsSettings.defaultFilters,
    defaultScaleYIndex: signalsSettings.defaultScaleYIndex,
    defaultScaleXIndex: signalsSettings.defaultScaleXIndex
  };
}

function createViewObjectUserSettings(viewObjectSettings) {
  if (viewObjectSettings === undefined) {
    return undefined;
  }
  switch (viewObjectSettings.type) {
    case "panel":
      return createPanelUserSettings(viewObjectSettings);
    case "grid":
      return createGridUserSettings(viewObjectSettings);
    case "column-grid":
      return createColumnGridUserSettings(viewObjectSettings);
    case "table":
      return createTableUserSettings(viewObjectSettings);
    case "plot":
      return createPlotUserSettings(viewObjectSettings);
    case "rhythm-plot":
      return createRhythmPlotUserSettings(viewObjectSettings);
  }
  return undefined;
}

export function createUserSettings(visSettings) {
  let userVisSettings = {
    viewObjects: []
  };
  if (visSettings?.view?.canvas?.items === undefined) {
    return userVisSettings;
  }
  let viewObjects = visSettings.view.canvas.items;
  for (let viewObjectIndex = 0; viewObjectIndex < viewObjects.length; viewObjectIndex++) {
    userVisSettings.viewObjects.push(createViewObjectUserSettings(viewObjects[viewObjectIndex]));
  }
  return userVisSettings;
}
